import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getPresignedUrl, downloadFile } from '../../../../Company/UploadJourney/components/UploadCard/utils/api/helpers';
import FileViewerDrawer from '../../../../../common/DocumentViewer/FileViewerDrawer';

interface CaseDocumentPreviewerProps {
    docIdToView: string;
    setDocIdToView: React.Dispatch<React.SetStateAction<string>>;
    label: string;
    /** Fired when the user actually downloads — opening the viewer is not a download. */
    onDownload?: () => void;
}

const CaseDocumentPreviewer: React.FC<CaseDocumentPreviewerProps> = ({ docIdToView, setDocIdToView, label, onDownload }) => {
    const [fileUrl, setFileUrl] = useState('');
    const [mimeType, setMimeType] = useState('');

    useEffect(() => {
        if (!docIdToView) {
            setFileUrl('');
            setMimeType('');
            return;
        }
        let cancelled = false;
        (async () => {
            const res = await getPresignedUrl({ docId: Number(docIdToView) }, false);
            if (cancelled) return;
            if (!res) {
                toast.error('Error in fetching file');
                setDocIdToView('');
                return;
            }
            setFileUrl(res.uri);
            setMimeType(res.fileType ?? 'application/pdf');
        })();
        return () => {
            cancelled = true;
        };
    }, [docIdToView, setDocIdToView]);

    if (!docIdToView || !fileUrl) return null;

    return (
        <FileViewerDrawer
            heading={label}
            fileUrl={fileUrl}
            mimeType={mimeType}
            onDownload={() => {
                onDownload?.();
                downloadFile(docIdToView);
            }}
            onClose={() => setDocIdToView('')}
        />
    );
};

export default CaseDocumentPreviewer;
